var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowNe = function SvgArrowNe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-ne_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.256 3.748a.73.73 0 0 0-.534-.21H5.824c-.23.004-.4.076-.525.201-.288.288-.292.696-.018.97a.699.699 0 0 0 .502.206l2.034.014 2.49-.112-1.103.978-5.44 5.44c-.301.3-.301.714-.005 1.01.292.292.705.292 1.006-.009l5.44-5.44.978-1.104-.112 2.491.013 2.033a.7.7 0 0 0 .207.503c.274.274.682.27.97-.018a.715.715 0 0 0 .201-.507V4.278a.728.728 0 0 0-.206-.53Z",
    fill: "currentColor"
  })));
};

export default SvgArrowNe;